import { render, staticRenderFns } from "./RecetaIngredientesHandler.vue?vue&type=template&id=60c3e21e&"
import script from "./RecetaIngredientesHandler.vue?vue&type=script&lang=js&"
export * from "./RecetaIngredientesHandler.vue?vue&type=script&lang=js&"
import style0 from "./RecetaIngredientesHandler.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports